import { Component, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { UnitsService } from '../shared/services/units-service';
import { IngredientsService } from '../shared/services/ingredints-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../shared/services/environment-url';
import { UnitsModel } from '../_interfaces/units';
import { CommonModule } from '@angular/common';
import { RecipeModel } from '../_interfaces/recipe';
import { ResipesService } from '../shared/services/resipes-service';
import { CardModule } from '@openng/optimus-ui/card';
import { TableModule } from '@openng/optimus-ui/table';
import { IngredientModel } from '../_interfaces/ingredient';

@Component({
  selector: 'app-resibe',
  imports: [TableModule, CommonModule, CardModule],
  templateUrl: './recipe.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './recipe.css',
})
export class Resibe {
  @Input() id!: number;
  resibesService?: ResipesService;
  unitsService?: UnitsService;
  ingredientsService?: IngredientsService;
  types: UnitsModel[] = [];
  ingredients: IngredientModel[] = [];
  data: RecipeModel = {
    id: -1,
    name: '',
    cooktimeS: 0,
    oventimeS: 0,
    timeSpentInKichenS: 0,
    totalTimeS: 0,
    description: '',
    endDescription: '',
    servings: 0,
    servings2: 0,
    servingsNode: '',
    category: null,
    ingredients: [],
  };

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
  ) {
    this.resibesService = new ResipesService(this.http, this.envUrl);
    this.unitsService = new UnitsService(this.http, this.envUrl);
    this.unitsService.list().subscribe((res) => (this.types = res as UnitsModel[]));
    this.ingredientsService = new IngredientsService(this.http, this.envUrl);
    this.ingredientsService
      .list()
      .subscribe((res) => (this.ingredients = res as IngredientModel[]));
  }

  ngAfterViewInit() {
    if (this.id > 0) {
      this.resibesService?.get(this.id).subscribe((at) => {
        this.data = at as RecipeModel;
        this.changeDetectorRef.detectChanges();
      });
    }
  }
}
